import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { TableFiltersProps } from 'modules/types'
import { FC } from 'react'
import { AClearFiltersButton } from 'views/components/Analytics'
import { FiltersAndSearchWrapper, FiltersWrapper } from 'views/components/CommonTableComponents/CommonTableComponents'
import { CropsFilter } from 'views/components/TableFilters'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { ADateRangePicker } from 'views/components/TableFilters/DateRangePicker/ADateRangePicker'
import { SingleRegionFilter } from 'views/components/TableFilters/SingleRegionFilter'

const RuCoutryProvinceID = 3
const regionsFilter = { parent_id: RuCoutryProvinceID }
export const SellerPotentialFilters: FC<TableFiltersProps> = ({
  setListRequestParams,
  updateFilterState,
  listRequestParams,
}) => {
  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
  })

  return (
    <FiltersAndSearchWrapper>
      <FiltersWrapper>
        <CropsFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} multiple={false} />
        <SingleRegionFilter
          listRequestParams={listRequestParams}
          updateFilterState={updateFilterState}
          onClear={() => updateFilterState({ region: [], district: [] })}
          multiple={false}
          filter={regionsFilter}
        />
        <ADateRangePicker
          value={[listRequestParams.filter.modified_after, listRequestParams.filter.modified_before]}
          onChange={(value) => updateFilterState({ modified_after: value.startDate, modified_before: value.endDate })}
          id="dateFilter"
          picker="month"
        />
        {displayClearBtn && (
          <AClearFiltersButton onClick={() => setListRequestParams({ ...defaultListRequestParams })} />
        )}
      </FiltersWrapper>
    </FiltersAndSearchWrapper>
  )
}
